import React, { useState, useEffect } from "react";
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import { Skeleton, Button, Tag, Modal, Row as ARow, Col as ACol, Space, notification, Drawer, Image, QRCode } from 'antd';
import Common from "./includes/Common";
import Moment from 'react-moment';
import { useOutletContext } from "react-router-dom";
import { NodePlusFill, TicketPerforatedFill, GeoAltFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var TicketViewCardWhiteLabel = function TicketViewCardWhiteLabel(_ref) {
  var ticket = _ref.ticket;
  var getContrastColor = function getContrastColor(bgColor) {
    // Convert hex color to RGB
    var r = parseInt(bgColor.substr(1, 2), 16);
    var g = parseInt(bgColor.substr(3, 2), 16);
    var b = parseInt(bgColor.substr(5, 2), 16);

    // Calculate brightness using YIQ formula 
    var brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 128 ? 'black' : 'white'; // Choose best contrast
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx("div", {
        style: {
          borderRadius: "4px",
          boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
          minHeight: '300px',
          backgroundImage: 'url(' + ticket.price_schema_item.image + ')',
          backgroundSize: '100% 100%'
        },
        children: /*#__PURE__*/_jsxs(ARow, {
          children: [/*#__PURE__*/_jsx(ACol, {
            lg: 18,
            md: 18,
            sm: 18,
            xs: 18
          }), /*#__PURE__*/_jsxs(ACol, {
            lg: 5,
            md: 5,
            sm: 5,
            xs: 5,
            children: [/*#__PURE__*/_jsx("div", {
              style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                borderRadius: "4px",
                padding: "35px 2px 2px 2px"
              },
              children: /*#__PURE__*/_jsx(QRCode, {
                size: 130,
                color: ticket.price_schema_item.color,
                value: ticket.id.toString()
              })
            }), /*#__PURE__*/_jsx("div", {
              style: {
                textAlign: "center",
                fontSize: "12px",
                color: ticket.price_schema_item.color,
                textTransform: "uppercase"
              },
              children: ticket.ticket_code
            })]
          }), /*#__PURE__*/_jsx(ACol, {
            lg: 1,
            md: 1,
            sm: 1,
            xs: 1,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                color: "#FEF4EA",
                fontWeight: 'bold',
                writingMode: 'vertical-lr',
                textTransform: "uppercase",
                paddingTop: "35px"
              },
              children: ticket.ticket_code
            })
          })]
        })
      })
    })
  });
};
export default TicketViewCardWhiteLabel;